import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AnalyticsService } from '../analytics/analytics.service'

export type LanguageSelection = {
  key: string
  label: string
}
export const DEFAULT_LANGUAGE = 'de'
const AVAILABLE_LANGUAGES = ['de', 'en']

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  get availableLanguages(): string[] {
    return AVAILABLE_LANGUAGES
  }

  get currentLanugage(): string {
    return this.translateService.currentLang ?? DEFAULT_LANGUAGE
  }

  get currentLocale(): string {
    return this.translateService.getBrowserCultureLang()
  }

  get imprintPath(): string {
    switch (this.currentLanugage) {
      case 'en':
        return 'assets/imprint/en.html'
      default:
        return 'assets/imprint/de.html'
    }
  }

  get languageSelection(): LanguageSelection[] {
    return AVAILABLE_LANGUAGES.flatMap((lang) => {
      return {
        key: lang,
        label: `language.${lang}`,
      }
    })
  }

  constructor(
    private translateService: TranslateService,
    private analyticsService: AnalyticsService
  ) {}

  initTranslations() {
    this.translateService.addLangs(AVAILABLE_LANGUAGES)
    const userLanguage = this.translateService.getBrowserLang()
    const appLanguage = AVAILABLE_LANGUAGES.includes(userLanguage)
      ? userLanguage
      : this.translateService.defaultLang
    this.translateService.use(appLanguage)
    this.analyticsService.setUserLanguage(appLanguage)
  }

  getPrivacyPolicyPath(language: string = this.currentLanugage): string {
    switch (language) {
      case 'en':
        return 'assets/data-privacy/en.html'
      default:
        return 'assets/data-privacy/de.html'
    }
  }
}
